var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestRail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E3266C;}\r\n\t.st1{fill:#3BB850;}\r\n\t.st2{fill:#47B15A;}\r\n\t.st3{fill:#FBC200;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,61.4c0-1.4,0-2.8,0-4.2c0-1,0.8-1.8,1.8-1.8c2.8,0,5.7,0,8.5,0c1,0,1.7,0.7,1.8,1.7c0,0.9,0,1.8,0,2.7 c0,1.9,0,3.7,0,5.6c0,1.5-0.6,2.2-2.2,2.2c-2.6,0-5.3,0-7.9,0c-1,0-2-0.8-2-2C75.6,64.2,75.5,62.8,75.5,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,29.1c0,1.3,0,2.7,0,4c0,1.3-0.7,2-2,2c-2.6,0-5.3,0-7.9,0c-1.3,0-2.1-0.7-2.1-2c0-2.7,0-5.4,0-8 c0-1.2,0.7-2,2-2c2.7,0,5.4,0,8,0c1.3,0,2,0.7,2,2C55.2,26.4,55.2,27.7,55.2,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.2,45.3c0-1.4,0-2.8,0-4.1c0-1.1,0.8-1.9,1.9-1.9c2.8,0,5.6,0,8.4,0c1,0,1.8,0.7,1.8,1.7c0,2.9,0,5.7,0,8.6 c0,1-0.8,1.7-1.8,1.8c-2.8,0-5.6,0-8.3,0c-1.1,0-1.9-0.8-1.9-1.9C43.2,48,43.2,46.7,43.2,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.3,45.3c0-1.4,0-2.8,0-4.1c0-1.1,0.8-1.9,1.9-1.9c2.8,0,5.6,0,8.4,0c1,0,1.8,0.7,1.8,1.7c0,2.9,0,5.7,0,8.6 c0,1-0.8,1.7-1.8,1.8c-2.8,0-5.6,0-8.3,0c-1.1,0-1.9-0.8-1.9-1.9C59.3,48,59.3,46.7,59.3,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,61.4c0,1.3,0,2.7,0,4c0,1.4-0.7,2.1-2.1,2.1c-2.6,0-5.3,0-7.9,0c-1.3,0-2-0.7-2-2.1c0-2.7,0-5.4,0-8 c0-1.3,0.7-2,2-2c2.7,0,5.4,0,8.1,0c1.2,0,1.9,0.7,1.9,1.9C55.2,58.7,55.2,60.1,55.2,61.4C55.2,61.4,55.2,61.4,55.2,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.4,61.5c0,1.3,0,2.7,0,4c0,1.3-0.7,2-2,2c-2.7,0-5.3,0-8,0c-1.3,0-2-0.8-2-2c0-2.7,0-5.4,0-8.1 c0-1.3,0.7-2,2-2c2.7,0,5.4,0,8.1,0c1.2,0,1.9,0.7,1.9,1.9C71.4,58.7,71.4,60.1,71.4,61.5C71.4,61.5,71.4,61.5,71.4,61.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestRail);
export default __webpack_public_path__ + "static/media/TestRail.9613c5e604b36127c41b918e0a24963e.svg";
export { ForwardRef as ReactComponent };